import { greet } from '@aithora/shared';
import { useSession } from '../session/SessionContext';
import { useLang } from '../i18n/LangContext';

/**
 * "Good morning, Ana" for the signed-in person, by their building's clock (server /auth/me
 * time_zone) or else this browser's (Andrew, 2026-10-19). One helper for every home and Atlas.
 */
export function useGreeting(now: Date = new Date()): string {
  const { session } = useSession();
  const { lang } = useLang();
  // Spanish has its own hours (tardes to 8 PM), so it is written here, not translated.
  return greet(session?.user.name, now, session?.user.timeZone ?? null, lang === 'es' ? 'es' : 'en');
}
